import { DisplayItem } from "../Common/Models/CustomTypes";
import { NetworkConfig, ApiConfig } from "../Common/Models/NetworkConfig";

// Celo Rivera APIs with authorization keyed
// to the production Auth0 tenant
//

const MAINNET_CELO_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-celo.atalma.io",
	basePath: "/mainnet",
};

const BAKLAVA_CELO_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-celo.atalma.io",
	basePath: "/baklava",
};

const NYM_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-comet.atalma.io",
	basePath: "/nym-mainnet",
};

// Celo Rivera APIs with authorization keyed
// to the development Auth0 tenant
// (use this for localhost development)
//

const MAINNET_DEV_CELO_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-celo.atalma.io",
	basePath: "/mainnet",
};

const BAKLAVA_DEV_CELO_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-celo.atalma.io",
	basePath: "/baklava",
};

const ICP_RIVERA_HOST: ApiConfig = {
	host: "https://api.rivera-icp.atalma.io",
	basePath: "/ic",
};

let mainnetApiConfig: ApiConfig = MAINNET_CELO_RIVERA_HOST;
let baklavaApiConfig: ApiConfig = BAKLAVA_CELO_RIVERA_HOST;
let nymApiConfig: ApiConfig = NYM_RIVERA_HOST;
let icpApiConfig: ApiConfig = ICP_RIVERA_HOST;

if (window.location.hostname === "localhost") {
	console.log("Switching to staging API config");
	mainnetApiConfig = MAINNET_DEV_CELO_RIVERA_HOST;
	baklavaApiConfig = BAKLAVA_DEV_CELO_RIVERA_HOST;
	nymApiConfig = NYM_RIVERA_HOST;
	icpApiConfig = ICP_RIVERA_HOST;
} else if (window.location.hostname === "dev.vido.atalma.io") {
	console.log("Switching to staging API config");
	mainnetApiConfig = MAINNET_DEV_CELO_RIVERA_HOST;
	baklavaApiConfig = BAKLAVA_DEV_CELO_RIVERA_HOST;
	nymApiConfig = NYM_RIVERA_HOST;
	icpApiConfig = ICP_RIVERA_HOST;
}

const NETWORK_CONFIG: NetworkConfig[] = [
	{
		network: "baklava",
		remoteNode: "https://baklava-forno.celo-testnet.org",
		blockExplorer: "https://celo-baklava.blockscout.com/",
		apiAudience: "https://api.rivera-celo.atalma.io",
		signedBlocksConfig: {
			api: baklavaApiConfig,
			firstBlock: 17280,
			paginationListLength: 12,
			defaultViewSize: 100,
		},
		rpcConfig: {
			api: baklavaApiConfig,
		},
		attestationConfig: {
			api: baklavaApiConfig,
			defaultViewSize: 100,
		},
		metricsConfig: {
			api: baklavaApiConfig,
		},
		subscriptionConfig: {
			api: baklavaApiConfig,
		},
	},

	{
		network: "mainnet",
		remoteNode: "https://forno.celo.org",
		blockExplorer: "https://celo.blockscout.com/",
		apiAudience: "https://api.rivera-celo.atalma.io",
		signedBlocksConfig: {
			api: mainnetApiConfig,
			firstBlock: 17280,
			paginationListLength: 12,
			defaultViewSize: 100,
		},
		rpcConfig: {
			api: mainnetApiConfig,
		},
		attestationConfig: {
			api: mainnetApiConfig,
			defaultViewSize: 100,
		},
		metricsConfig: {
			api: mainnetApiConfig,
		},
		subscriptionConfig: {
			api: mainnetApiConfig,
		},
	},
	{
		network: "nym",
		remoteNode: "https://rpc.nymtech.net:443",
		blockExplorer: "https://nym.explorers.guru/validator/",
		apiAudience: "https://api.rivera-celo.atalma.io",
		signedBlocksConfig: {
			api: nymApiConfig,
			firstBlock: 2,
			paginationListLength: 12,
			defaultViewSize: 100,
		},
		attestationConfig: {
			api: nymApiConfig,
			defaultViewSize: 100,
		},
		metricsConfig: {
			api: nymApiConfig,
		},
		subscriptionConfig: {
			api: nymApiConfig,
		},
	},
	{
		network: "icp",
		remoteNode: "not.supplied.com",
		blockExplorer: "not.supplied.com",
		apiAudience: "https://api.rivera-celo.atalma.io",
		signedBlocksConfig: {
			api: icpApiConfig,
			firstBlock: 2,
			paginationListLength: 12,
			defaultViewSize: 100,
		},
		attestationConfig: {
			api: icpApiConfig,
			defaultViewSize: 100,
		},
		metricsConfig: {
			api: icpApiConfig,
		},
		subscriptionConfig: {
			api: icpApiConfig,
		},
	},
];

export const RpcApisWithThirdParty: DisplayItem[] = [
	{
		displayText: "atalma.io",
		key: "atalma.io",
		value: "atalma.io",
	},
	{
		displayText: "atweb3",
		key: "atweb3",
		value: "atweb3",
	},
	{
		displayText: "usopp.club",
		key: "usopp.club",
		value: "usopp.club",
	},
];

export function getThirdPartyRpcApiConfig(
	thirdParty: string,
	network: string,
): ApiConfig {
	console.log("thirdParty", thirdParty);
	let config: ApiConfig = null;
	switch (thirdParty) {
		case "atalma.io":
			config = {
				host: "https://api.rivera-celo.atalma.io",
				basePath: network,
			};
			break;
		case "atweb3":
			config = {
				host: "https://celo-uptime-api.atweb3.network",
				basePath: network,
			};
			break;
		case "usopp.club":
			config = {
				host: "https://vido.usopp.club",
				basePath: network,
			};
			break;
		default:
			config = {
				host: "https://api.rivera-celo.atalma.io",
				basePath: network,
			};
	}
	console.log("config", config);
	return config;
}

export const validatorGroupLink =
	"https://explorer.celo.org/address/0x70FC0b021dFdBb9A106D1Ed8F35f59D3f23eCb7B/celo";
export const validatorGroup = "0x70FC0b021dFdBb9A106D1Ed8F35f59D3f23eCb7B";

export function getConfigForNetwork(network: string): NetworkConfig {
	const config: NetworkConfig = NETWORK_CONFIG.filter(
		(item) => item.network.toLowerCase() === network.toLowerCase(),
	)[0];
	return config;
}

export function getLinkForAddress(network: string, address: string): string {
	const config = getConfigForNetwork(network);
	return `${config.blockExplorer}/address/${address}`;
}
